import React from 'react';
import { Box, IconButton, Tooltip } from '@mui/material';
import { FileDownload, Visibility, Delete } from '@mui/icons-material';
import * as g04docuFileActions from '../../store/g04docuFile';

export const downloadDocument = async (documentPath, fileName) => {
  const res = await g04docuFileActions.downloadDirect(documentPath);
  if (!res.ok) {
    throw new Error('다운로드에 실패했습니다.');
  }
  const blob = await res.blob();
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName || documentPath.split('/').pop());
  document.body.appendChild(link);
  link.click();
  link.parentNode.removeChild(link);
  window.URL.revokeObjectURL(url);
};

/** 미리보기용 blob URL 생성 (호출측에서 revoke) */
export const createPreviewObjectUrl = async (documentPath) => {
  const res = await g04docuFileActions.downloadDirect(documentPath);
  if (!res.ok) {
    throw new Error('파일을 열 수 없습니다.');
  }
  const blob = await res.blob();
  return window.URL.createObjectURL(new Blob([blob], { type: blob.type || 'application/pdf' }));
};

/** @deprecated 새 탭 대신 createPreviewObjectUrl + DocumentViewerDrawer 사용 */
export const viewDocument = async (documentPath) => {
  const url = await createPreviewObjectUrl(documentPath);
  window.open(url, '_blank', 'noopener,noreferrer');
  setTimeout(() => window.URL.revokeObjectURL(url), 60000);
};

const SubMatFolderFileActions = ({ file, onError, onDelete, onPreview }) => {
  if (!file?.documentPath) return null;

  const handleView = async () => {
    try {
      if (onPreview) {
        await onPreview(file);
        return;
      }
      await viewDocument(file.documentPath);
    } catch (err) {
      onError(err.message || '파일을 열 수 없습니다.');
    }
  };

  const handleDownload = async () => {
    try {
      await downloadDocument(file.documentPath, file.fileName);
    } catch (err) {
      onError(err.message || '다운로드에 실패했습니다.');
    }
  };

  return (
    <Box sx={{ display: 'inline-flex', gap: 0.25, verticalAlign: 'middle' }}>
      <Tooltip title="파일 보기">
        <IconButton size="small" onClick={handleView} aria-label="파일 보기">
          <Visibility fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title="다운로드">
        <IconButton size="small" onClick={handleDownload} aria-label="다운로드">
          <FileDownload fontSize="small" />
        </IconButton>
      </Tooltip>
      {onDelete && (
        <Tooltip title="삭제">
          <IconButton
            size="small"
            color="error"
            onClick={(e) => {
              e.stopPropagation();
              onDelete(file);
            }}
            aria-label="삭제"
          >
            <Delete fontSize="small" />
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
};

export default SubMatFolderFileActions;
